import React, { Component } from "react"
import Img from 'gatsby-image'

class HouseRooms extends Component {
  render() {

    let rooms = this.props.rooms

    return(
      <div className="wrap--mini">
        <div className="house-rooms">
          <div  className="house-rooms__body">
            { rooms.map(room => {

              let roomName = room.room.name.replace(/[^a-zA-Z0-9]/g,'')

              return(
                <div
                  key={ room.id }
                  className="house-rooms__item"
                >
                  <span
                    className={`house-rooms__icon ${roomName}`}
                  />
                  { room.number }
                  <span> </span>
                  { room.room.name }
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default HouseRooms



// WEBPACK FOOTER //
// ./src/components/HouseRooms/index.js